module.exports = __webpack_public_path__ + "static/media/31.43e71d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/31.png
// module id = 814
// module chunks = 0